var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13V13C10 9.68629 12.6863 7 16 7V7C19.3137 7 22 9.68629 22 13V13",
    stroke: "#999999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 3,
    height: 2,
    rx: 1,
    stroke: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V18C22 19.1046 21.1046 20 20 20V20",
    stroke: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C8 13.8954 8.89543 13 10 13H11V18H10C8.89543 18 8 17.1046 8 16V15Z",
    stroke: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C24 17.1046 23.1046 18 22 18L21 18L21 13L22 13C23.1046 13 24 13.8954 24 15L24 16Z",
    stroke: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7V21C3 23.2091 4.79086 25 7 25H13.1716C13.702 25 14.2107 25.2107 14.5858 25.5858L16.2929 27.2929C16.6834 27.6834 17.3166 27.6834 17.7071 27.2929L19.4142 25.5858C19.7893 25.2107 20.298 25 20.8284 25H25C27.2091 25 29 23.2091 29 21V7C29 4.79086 27.2091 3 25 3H7C4.79086 3 3 4.79086 3 7Z",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatGray);
export default __webpack_public_path__ + "static/media/ic_chat_gray.816b0252de2693666cb403a3379d0e69.svg";
export { ForwardRef as ReactComponent };